module.exports = __webpack_public_path__ + "static/img/53.43193586.jpg";